export default __webpack_public_path__ + "static/media/deleted.f6bbd268.svg";